/**
 * Single clickable item
 */
export interface NavItem {
  /**
   * Unique id of the item
   */
  id: string;
  /**
   * Text for the item
   */
  text: string;
  /**
   * URL of the link service
   */
  href: string;
  /**
   * (Optional) secondary sub items of the item. defaults to undefined
   */
  subItems?: NavItem[];
}

export enum MenuColumnTheme {
  DARK_GREY = 'DARK_GREY',
  BLUE_GREY = 'BLUE_GREY',
  BLUE_GREY_75 = 'BLUE_GREY_75'
}
